import type { MonospaceDataSource } from '#layers/data-model';
import { RStoreSchema } from '#imports';

export const DataSource = RStoreSchema.withItemType<MonospaceDataSource>().defineCollection({
	name: 'MonospaceDataSource',
	scopeId: 'monospace-default',
	meta: {
		defaultFields: ['id', 'apiName', 'provider', 'preset'],
		useProjectSlug: true,
	},
});
